export default "<p>\n  contact works!\n</p>\n";